import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import PayrollBatchesTab from "@/pages/hr/payroll/PayrollBatchesTab";
import PayrollProfilesTab from "@/pages/hr/payroll/PayrollProfilesTab";
import PayrollComponentsTab from "@/pages/hr/payroll/PayrollComponentsTab";
import AttendanceAllowanceTab from "@/pages/hr/payroll/AttendanceAllowanceTab";
import StatutorySetupTab from "@/pages/hr/payroll/StatutorySetupTab";
import PayrollReadinessTab from "@/pages/hr/payroll/PayrollReadinessTab";
import PayrollArchiveTab from "@/pages/hr/PayrollArchiveTab";
import { Lock } from "lucide-react";

export default function PayrollTab() {
  const { can } = useAuth();
  const [employees, setEmployees] = useState([]);
  const [components, setComponents] = useState([]);
  const [leaveTypes, setLeaveTypes] = useState([]);

  const reloadComponents = () => api.get("/hr/payroll/components").then((r) => setComponents(r.data)).catch(() => {});
  useEffect(() => {
    api.get("/hr/employees").then((r) => setEmployees(r.data)).catch(() => {});
    api.get("/hr/leave/types/active").then((r) => setLeaveTypes(r.data)).catch(() => {});
    reloadComponents();
  }, []);

  const shared = { employees, components, leaveTypes, reloadComponents };
  const anyPayroll = can("payroll:view") || can("payroll:process") || can("payroll:review") ||
    can("payroll:finalize") || can("payroll:manage_profiles") || can("payroll:adjust") || can("payroll:statutory_manage");

  const subtabs = [
    { id: "batches", label: "Payroll Batches", show: anyPayroll, el: <PayrollBatchesTab {...shared} /> },
    { id: "profiles", label: "Payroll Profiles", show: anyPayroll, el: <PayrollProfilesTab {...shared} /> },
    { id: "components", label: "Payroll Components", show: anyPayroll, el: <PayrollComponentsTab {...shared} /> },
    { id: "allowance", label: "Attendance Allowance", show: anyPayroll, el: <AttendanceAllowanceTab {...shared} /> },
    { id: "statutory", label: "Statutory Setup", show: anyPayroll, el: <StatutorySetupTab /> },
    { id: "readiness", label: "Readiness", show: anyPayroll, el: <PayrollReadinessTab /> },
    { id: "historical", label: "Historical (AutoCount)", show: can("payroll_history:view"), el: <PayrollArchiveTab /> },
  ].filter((t) => t.show);
  const [tab, setTab] = useState(subtabs[0]?.id);

  return (
    <div data-testid="hr-payroll-erp-tab">
      <div className="rounded-md bg-sky-50 border border-sky-200 text-sky-900 text-xs p-2.5 mb-3 flex items-start gap-2">
        <Lock className="w-3.5 h-3.5 mt-0.5 shrink-0" />
        <span><b>Shadow Mode (2026).</b> AutoCount remains the official payroll/statutory engine through Dec 2026.
          ERP Payroll calculates & compares against AutoCount to validate EPF / SOCSO / EIS / PCB before ERP becomes
          the production engine in 2027. <b>PCB is provisional — pending full LHDN rule implementation / validation.</b></span>
      </div>
      <div className="flex gap-1 mb-4 flex-wrap">
        {subtabs.map((t) => (
          <button key={t.id} data-testid={`payroll-subtab-${t.id}`} onClick={() => setTab(t.id)}
            className={`px-3 py-1.5 text-sm rounded-md font-medium ${tab === t.id ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>{t.label}</button>
        ))}
      </div>
      {subtabs.find((t) => t.id === tab)?.el}
    </div>
  );
}
